<template>
    <div class="w-100 h-100 d-flex flex-column align-items-start justify-content-between pb-4">
        <TextArea
            v-model="prompt"
            :id="'inputPrompt'"
            name="prompt"
            :border-class="'br-4'"
            :aiCustom="true"
            :skipFocus="true"
            :rows="'4'"
            :max-characters="4000"
            :label="getTextAreaPlaceholder"
            class="mb-2 w-100 styled-text-area" 
            type="text"
        ></TextArea>

        <TextInput
            :id="'inputNegativePrompt'"
            v-model="negative_prompt"
            :border-class="'br-4'"
            :aiCustom="true"
            type="text" 
            name="negative_prompt" 
            :label="getTextInputPlaceholder"
            class="w-100 styled-text-input"
        ></TextInput>
    </div>
</template>

<script>
import TransFilter from '../../../../qaamgo/modules/sat/components/mixins/TransFilter';
import { translate } from '../../../../qaamgo/helper/translate';
import ButtonWithLoadingState from '../../../../qaamgo/modules/sat/components/form/ButtonWithLoadingState';
import TextArea from '../../../../qaamgo/modules/sat/components/form/TextArea.vue';
import TextInput from '../../../../qaamgo/modules/sat/components/form/TextInput.vue';

export default {
  name: 'AIGenerationView',
  components: {TextInput, TextArea, ButtonWithLoadingState},
  mixins: [TransFilter],
  computed: {
    getTextAreaPlaceholder() {
      return translate("Describe what you want to see");
    },
    getTextInputPlaceholder() {
      return translate("Describe what you don't want to see");
    },
  },
  data() {
    return {
      isSubmitting: false,
      prompt: '',
      negative_prompt: '',
    };
  },
};
</script>

<style scoped>
.styled-text-area {
    border-radius: 9px;
    background: #424242;
    color: #e8eaed;
}

.styled-text-input {
    border-radius: 9px;
    background: #424242;
    color: #e8eaed;
}
</style>
